export const SET = 'timeReports/SET';
